export default class ovatBillChangeUkeyModalCtrl {
    constructor($scope, $uibModalInstance, httpRequest, logger, Upload, $timeout, $rootScope, $uibModal) {
        $scope.billInfo = {}
        // var qryBillInfo = function(billId){
        //     httpRequest.get_qryBillInfo(billId).then(res=>{
        //         $scope.billInfo = res.data.value
        //     })
        // }
        // qryBillInfo($scope.items);


        // 带搜索功能的下拉选择框相关方法
        function toSelect2data(list, idfield, textfield) {
            const result = []
            for (const a in list) {
                const tempdata = {
                    id: '',
                    text: ''
                }
                $.extend(tempdata, list[a])
                tempdata.id = list[a][idfield]
                tempdata.text = list[a][textfield]
                result.push(tempdata)
            }
            return result
        }
        $scope.config2 = {}
        $scope.aS2 = {}
        $scope.aS2.ukeyId = JSON.parse(localStorage.user_info).sysUkeyList[0].ukeyId
        $scope.billInfo.ukeyId = $scope.aS2.ukeyId
        // httpRequest.post_getAssignUkeyList().then(res=>{
        //     $scope.config2.data = toSelect2data(res.data.value, "ukeyId", "ukeyName");
        // })
        $scope.config2.data = toSelect2data($scope.userInfo.sysUkeyList, 'ukeyId', 'ukeyName')

        $scope.ok = function () {
            if ($scope.aS2.ukeyId == undefined || $scope.aS2.ukeyId == '') {
                logger.logError('请选择开票点')
                return
            }
            $scope.billInfo.ukeyId = $scope.aS2.ukeyId


            $uibModalInstance.close($scope.billInfo.ukeyId)
        }

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel')
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/outputManage/fillOpenManage/redWordInfo/redInfoChangeUkeyModalCtrl.js